import React from 'react';
import Select from 'react-select';
import { Vessel } from '../../../types/ViewModel/Vessel/Vessel';
import { SelectOption } from '../../../types/ViewModel/SelectOption';

type Props = {
    onChange: (ev: any) => void;
    vesselList: Vessel[];
    selectedVessel: Vessel | null;
    width: string;
    height?: string;
};

const SelectVesselComponent: React.FC<Props> = (props) => {
    const mappedOptions = (): SelectOption[] => {
        const vList: SelectOption[] = props.vesselList.map((v) => {
            return new SelectOption(v.imoNumber.toString(), v.vesselName);
        });
        return vList.sort((a, b) => a.label.localeCompare(b.label));
    };

    const mappedSelectedShip = (): SelectOption | null => {
        if (props.selectedVessel) {
            return new SelectOption(props.selectedVessel.imoNumber.toString(), props.selectedVessel.vesselName);
        }
        return null;
    };

    const styles = {
        control: (css) => ({
            ...css,
            display: 'inline-flex',
            width: props.width,
            minHeight: props.height ? props.height : '38px',
            height: props.height ? props.height : 'auto',
        }),
    };

    return (
        <Select
            className="select-container"
            value={mappedSelectedShip()}
            options={mappedOptions()}
            onChange={props.onChange}
            styles={styles}
            isSearchable={true}
            classNamePrefix="react-select"
        />
    );
};

export default SelectVesselComponent;
